// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"203a3df4","455":"86cd8fd0","977":"b3a74e84"}[chunkId] + ".chunk.js";
};